import { CartActions, isIgFullGearEnabled, whenIgFullGearEnabled } from "@theme/cart-actions";
import { ThemeEvents } from "@theme/events";

const COPY = {
  adding: "Adding your knife…",
  error: "We couldn't add the knife and free Zubo. Please try again.",
};

class CartLadderRungTwo extends HTMLElement {
  constructor() {
    super();
    this.cartActions = new CartActions();
    /** @type {HTMLElement | null} */
    this.status = null;
    /** @type {HTMLButtonElement[]} */
    this.knifeButtons = [];
    this.zuboVariantId = 0;
    /** @type {number | null} */
    this.selectedVariantId = null;
    this.handleCartError = this.handleCartError.bind(this);
  }

  connectedCallback() {
    this.status = /** @type {HTMLElement | null} */ (
      this.querySelector("[data-rung-two-status]")
    );
    this.knifeButtons = [
      ...this.querySelectorAll("[data-rung-two-knife]"),
    ].filter(
      /** @returns {button is HTMLButtonElement} */
      (button) => button instanceof HTMLButtonElement,
    );
    this.zuboVariantId = Number(this.dataset.zuboVariantId);

    if (!this.status || !this.zuboVariantId || this.knifeButtons.length === 0) return;

    this.knifeButtons.forEach((button) => {
      button.addEventListener("click", () => this.addKnife(button));
    });

    document.addEventListener(ThemeEvents.cartError, this.handleCartError);

    whenIgFullGearEnabled(() => {
      const drawer = this.closest(".cart-drawer__dialog");
      const julySpecial = /** @type {HTMLElement | null | undefined} */ (
        drawer?.querySelector(".cart-drawer-july-special")
      );
      if (julySpecial) julySpecial.hidden = true;
    });
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartError, this.handleCartError);
  }

  /**
   * @param {HTMLButtonElement} button
   */
  addKnife(button) {
    if (!isIgFullGearEnabled()) return;
    if (this.getAttribute("aria-busy") === "true") return;

    this.selectedVariantId = Number(button.dataset.variantId);
    if (!this.selectedVariantId) return;
    this.addSelection();
  }

  addSelection() {
    if (!this.selectedVariantId) return;

    this.setLoading(true);

    this.cartActions.addItems(
      [
        {
          id: this.selectedVariantId,
          quantity: 1,
          properties: {
            _cart_ladder: "rung_2_choice",
          },
        },
        {
          id: this.zuboVariantId,
          quantity: 1,
          properties: {
            _discount_gift: "zubo_free",
            _gift_purchase: "true",
            _cart_ladder: "rung_2_zubo",
          },
        },
      ],
      () => {
        document.removeEventListener(ThemeEvents.cartError, this.handleCartError);
      },
    );
  }

  /**
   * @param {boolean} isLoading
   */
  setLoading(isLoading) {
    this.knifeButtons.forEach((button) => {
      button.disabled = isLoading;
    });
    if (this.status && isLoading) this.status.textContent = COPY.adding;
    this.setAttribute("aria-busy", isLoading ? "true" : "false");
  }

  /**
   * @param {Event} event
   */
  handleCartError(event) {
    const cartError = /** @type {CustomEvent} */ (event);
    if (cartError.detail?.sourceId !== "cart_actions_add_items") return;
    if (!this.status) return;

    this.setLoading(false);
    this.status.textContent =
      cartError.detail?.data?.description ||
      cartError.detail?.data?.message ||
      COPY.error;
  }
}

if (!customElements.get("cart-ladder-rung-two")) {
  customElements.define("cart-ladder-rung-two", CartLadderRungTwo);
}
